import { render, staticRenderFns } from "./SiteTrust.vue?vue&type=template&id=6664dafa&scoped=true"
import script from "./SiteTrust.vue?vue&type=script&lang=js"
export * from "./SiteTrust.vue?vue&type=script&lang=js"
import style0 from "./SiteTrust.vue?vue&type=style&index=0&id=6664dafa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6664dafa",
  null
  
)

export default component.exports